import { CHAT_VIEW_LAST_CHAT_ID_LOCALSTORAGE } from '../constants';
import { TChatId } from '../../../../../../types/rest/IRestChat';

export const setLastChatIdLocalStorage = (
    chatId: TChatId,
) => {
    localStorage.setItem(CHAT_VIEW_LAST_CHAT_ID_LOCALSTORAGE, chatId ? JSON.stringify(chatId) : null);
}
